import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="w-full px-6 md:px-10 lg:px-16 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1 — Brand */}
          <div>
            <img
              src="/assets/azosis logo.webp"
              alt="Azosis Technologies"
              className="h-8 md:h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-600 text-sm mb-6">
              Trusted technology consulting and managed services - Engineering
              Hub, Bangalore.
            </p>
            <a
              href="https://www.linkedin.com/company/azosisintl"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-sm text-gray-400 hover:text-azosis-gold hover:border-azosis-gold/50 transition-all"
            >
              <i className="ri-linkedin-fill text-sm"></i>
            </a>
          </div>

          {/* Column 2 — Navigation */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm tracking-wide mb-6 relative">
              Navigation
              <span className="absolute bottom-0 left-0 w-8 h-px bg-azosis-gold -mb-2"></span>
            </h4>

            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigate("/")}
                  className="text-gray-600 text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/services")}
                  className="text-gray-600 text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/about")}
                  className="text-gray-600 text-sm"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/case-studies")}
                  className="text-gray-600 text-sm"
                >
                  Case Studies
                </button>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-azosis-gold text-azosis-dark font-semibold text-sm tracking-wide hover:bg-azosis-goldLight transition-all duration-300 whitespace-nowrap"
                >
                  Contact
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </li>
            </ul>

           
          </div>

          
          {/* Column 4 — Contact */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm tracking-wide mb-6 relative">
              Contact
              <span className="absolute bottom-0 left-0 w-8 h-px bg-azosis-gold -mb-2"></span>
            </h4>

            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.azosis.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 text-sm"
                >
                  www.azosis.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 mt-16 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs whitespace-nowrap">
            © 2026 Azosis Technologies Private Limited. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-4 gap-y-1">
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              Terms of Service
            </a>
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              GDPR
            </a>
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              DMCA
            </a>
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              Usage
            </a>
            <a
              href="https://www.azosis.com/gc/policies/policies.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              Billing
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
